export const MERCHANT_CREATE_REQUEST = 'MERCHANT_CREATE_REQUEST';
export const MERCHANT_CREATE_SUCCESS = 'MERCHANT_CREATE_SUCCESS';
export const MERCHANT_CREATE_FAIL    = 'MERCHANT_CREATE_FAIL';
export const MERCHANT_CREATE_RESET   = 'MERCHANT_CREATE_RESET';

export const MERCHANT_BY_QR_REQUEST  = 'MERCHANT_BY_QR_REQUEST';
export const MERCHANT_BY_QR_SUCCESS  = 'MERCHANT_BY_QR_SUCCESS';
export const MERCHANT_BY_QR_FAIL     = 'MERCHANT_BY_QR_FAIL';

export const MERCHANT_LIST_REQUEST   = 'MERCHANT_LIST_REQUEST';
export const MERCHANT_LIST_SUCCESS   = 'MERCHANT_LIST_SUCCESS';
export const MERCHANT_LIST_FAIL      = 'MERCHANT_LIST_FAIL';
